import { Pipe } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
export class TimeSincePipe {
  translateService;
  constructor(translateService) {
    this.translateService = translateService;
  }
  transform(createdAt, userTimezoneOffset) {
    if (!createdAt) return '';
    const now = this.getCurrentDateInUserTimezone(userTimezoneOffset);
    // CreatedAt Date is already in user timezone offset --> Done in Notification service Backend
    const creationDate = new Date(createdAt);
    const seconds = Math.floor((now.getTime() - creationDate.getTime()) / 1000);
    const monthInterval = this.getMonthInterval(creationDate, now);
    let interval = monthInterval / 12;
    if (interval >= 1) return this.getTranslation(interval, 'X.DATE.YEAR-AGO', 'X.DATE.YEARS-AGO');
    interval = monthInterval;
    if (interval >= 1) return this.getTranslation(interval, 'X.DATE.MONTH-AGO', 'X.DATE.MONTHS-AGO');
    interval = Math.floor(seconds / 86400);
    if (interval >= 1) return this.getTranslation(interval, 'X.DATE.DAY-AGO', 'X.DATE.DAYS-AGO');
    interval = Math.floor(seconds / 3600);
    if (interval >= 1) return this.getTranslation(interval, 'X.DATE.HOUR-AGO', 'X.DATE.HOURS-AGO');
    interval = Math.floor(seconds / 60);
    if (interval >= 1) return this.getTranslation(interval, 'X.DATE.MINUTE-AGO', 'X.DATE.MINUTES-AGO');
    return this.getTranslation(Math.floor(seconds), 'X.DATE.SECOND-AGO', 'X.DATE.SECONDS-AGO');
  }
  getMonthInterval(firstDate, secondDate) {
    const firstDateStartDate = firstDate < secondDate;
    const endDate = firstDateStartDate ? secondDate : firstDate;
    const startDate = firstDateStartDate ? firstDate : secondDate;
    const startYear = startDate.getFullYear();
    const startMonth = startDate.getMonth();
    const endYear = endDate.getFullYear();
    const endMonth = endDate.getMonth();
    let months = (endYear - startYear) * 12 + (endMonth - startMonth);
    if (endDate.getDate() < startDate.getDate()) {
      months--;
    }
    return months;
  }
  getTranslation(interval, singleKey, pluralKey) {
    const translationKey = interval > 1 ? pluralKey : singleKey;
    return this.translateService.instant(translationKey, {
      value: interval
    });
  }
  getCurrentDateInUserTimezone(userTimezoneOffset) {
    if (!userTimezoneOffset) return new Date();
    const now = new Date();
    const systemOffset = now.getTimezoneOffset() * 60 * 1000;
    const userOffsetInMilliseconds = this.getUserTimezoneOffsetInMilliseconds(userTimezoneOffset);
    return new Date(now.getTime() + systemOffset + userOffsetInMilliseconds);
  }
  getUserTimezoneOffsetInMilliseconds(userTimezoneOffset) {
    // Extracts the Hours and Minutes from the userTimezoneOffset with the following Format: '+07:00' or '-04:30' for example
    const [sign, hours, minutes] = RegExp(/([+-])(\d{2}):(\d{2})/).exec(userTimezoneOffset)?.slice(1) ?? ['+', '00', '00'];
    return (sign === '+' ? 1 : -1) * (parseInt(hours, 10) * 60 + parseInt(minutes, 10)) * 60 * 1000;
  }
  static ɵfac = function TimeSincePipe_Factory(t) {
    return new (t || TimeSincePipe)(i0.ɵɵdirectiveInject(i1.TranslateService, 16));
  };
  static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "timeSince",
    type: TimeSincePipe,
    pure: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimeSincePipe, [{
    type: Pipe,
    args: [{
      name: 'timeSince'
    }]
  }], () => [{
    type: i1.TranslateService
  }], null);
})();
